export default "__VITE_ASSET__DadtXiK$__"